import React, {useState, useEffect, useContext} from 'react';
import Datepicker from 'react-datepicker';
import { parse } from 'date-fns';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import {CalendarIntakeBookContext} from '../contexts/CalendarIntakeBookProvider';
import { LabelText } from '../../components/Language/LabelText';
import HeaderTitle from '../../hoc/HeaderTitle';
import PrevNextDate from '../../components/UI/Date/PrevNextDate';
import './calendarintakebook.css';
import { enGB, fr, nl, de } from 'date-fns/locale';
import {registerLocale, setDefaultLocale} from 'react-datepicker';

export default function CalendarIntakeBook(props) {

    const { intakeBookStartDate, minDate, maxDate, isDateChanged, selectedIntakeBookDateHandler } = useContext(CalendarIntakeBookContext);
    const languageContext = useContext(LanguageContext);
    const date = intakeBookStartDate && parse(intakeBookStartDate, "dd/MM/yyyy", new Date());
    const [selectedIntakeBookDate, setSelectedDate] = useState(date);
    const localeList = [enGB, fr, nl, de];

    useEffect(() => {
        if(intakeBookStartDate) {
            setSelectedDate((parse(intakeBookStartDate, "dd/MM/yyyy", new Date())));
        }
    }, [isDateChanged]);

    useEffect(() => {
        if(intakeBookStartDate) {
            setSelectedDate((parse(intakeBookStartDate, "dd/MM/yyyy", new Date())));
        }
    }, [intakeBookStartDate]);

    useEffect(()=> {
        const selectedLanguage = languageContext && languageContext.language;
        if(selectedLanguage) {
            const selectedLangId = parseInt(selectedLanguage.id);
            registerLocale(selectedLanguage.text, localeList[selectedLangId-1]);
            setDefaultLocale(selectedLanguage.text); 
        }
    }, [languageContext.language.id])

    const handlerOnMonthChange = (selectedDate) => {
        if(selectedDate) {
            let oldDate = selectedIntakeBookDate;  
            setSelectedDate(selectedDate);
            selectedIntakeBookDateHandler(selectedDate, oldDate);
        }
    }

    // const handlerOnYearChange = (selectedDate) => {
    // }

    const BottomContentHeaderTitle = styled.div`
    font-size: 0.8vw;
    line-height: 3vh;
    text-align: left;
    padding: 0.2vw 0 0.3vw 1.4vw;
    color: #fff;
    `;

    const BottomContentDate = styled.div`
    font-size: 0.8vw;
    line-height: 3vh;
    text-align: left;
    color: #fff;  
    width: 5vw;
    padding: 0.2vw 1vw 0.3vw 1.4vw;
    margin-top: 0.5vw;    
    `;

    return (
        <Container className="calendar-intake-book-container">
            <Row className="calendar-intake-book-row">
                <Col className="calendar-intake-book-col">
                    <HeaderTitle>
                        <BottomContentHeaderTitle>
                            <LabelText tid="calendar_intakebook" />
                        </BottomContentHeaderTitle>
                    </HeaderTitle>
                </Col>
            </Row>
            <Row className="calendar-intake-book-row">
                <Col className="calendar-intake-book-col">
                    <BottomContentDate>
                        <LabelText tid="date" />
                    </BottomContentDate>    
                </Col>
                <Col className="calendar-intake-book-col-calendar-textbox">
                    {
                        intakeBookStartDate && <Datepicker className="form-control form-control-sm"
                            showPopperArrow={false}
                            strictParsing={true}
                            enableTabLoop = {false} 
                            onChange={modifiedDate => handlerOnMonthChange(modifiedDate)}
                            showMonthYearPicker
                            dateFormat="MM/yyyy"
                            selected={selectedIntakeBookDate}
                            minDate={minDate && parse(minDate, "dd/MM/yyyy", new Date())}
                            maxDate={maxDate && parse(maxDate, "dd/MM/yyyy", new Date())}
                            // onMonthChange={modifiedDate => handlerOnMonthChange(modifiedDate)}
                            // onYearChange={modifiedDate => handlerOnYearChange(modifiedDate)}
                    />} 
                </Col>
                <Col className="calendar-intake-book-col-prev-next-date">
                    {
                        intakeBookStartDate && <PrevNextDate className="date-arrow-container"
                                                isMonthlyIntakeCalender = {true}
                                                dateChangeHandler = {(e) => handlerOnMonthChange(e)} 
                                                revenueDate={selectedIntakeBookDate}
                                                minDate ={minDate} 
                                                maxDate={maxDate} />
                    }
                </Col>
            </Row>
            {intakeBookStartDate && <Row className="calendar-intake-book-row">
                <Col style={{margin: "0vw", padding: "0vw"}}>
                    <BottomContentDate>
                        <></>
                    </BottomContentDate>    
                </Col>
                <Col className="calendar-dateFormat">
                    <div><span>(MM/YYYY)</span></div>
                </Col>
                <Col className="calendar-intake-book-col-prev-next-date">
                    <></>
                </Col>
            </Row>}
            <Row className="calendar-intake-book-row">
                <Col className="calendar-intake-book-col-calendar">
                    {
                        intakeBookStartDate && <Datepicker className="form-control form-control-sm"
                            title="Revenue date calendar"
                            inline
                            onChange={modifiedDate => handlerOnMonthChange(modifiedDate)}
                            strictParsing={true}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            selected={selectedIntakeBookDate}
                            minDate={minDate && parse(minDate, "dd/MM/yyyy", new Date())}
                            maxDate={maxDate && parse(maxDate, "dd/MM/yyyy", new Date())}           
                            // onMonthChange={modifiedDate => handlerOnMonthChange(modifiedDate)}
                            // onYearChange={modifiedDate => handlerOnYearChange(modifiedDate)}
                        />
                    }
                   
                </Col>
            </Row>
        </Container>
    );
}